import React from 'react';
import PropTypes from 'prop-types';

import { NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP } from 'common/entities/formNode/nodeNames';
import AdditionalGuestsLayoutSubSection from './AdditionalGuestsLayoutSubSection';

const componentsByName = {
    [NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP]: AdditionalGuestsLayoutSubSection,
};

/**
 * Switch component to decide which sub section to render.
 */
const LayoutNodeSubSection = (props) => {
    const Component = componentsByName[props.formNode.name];
    return Component ? <Component {...props} /> : null;
};

LayoutNodeSubSection.propTypes = {
    formNode: PropTypes.object.isRequired,
};

export default LayoutNodeSubSection;
